import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { CountryModel, CurrencyModel, IncoTermModel, UnitModel } from '@data-layer/models/common';
import { map } from 'rxjs/operators';
import { FIRST_INCOTERMS } from '@constants/constants';

@Injectable({
  providedIn: 'root',
})
export class OnlineRepository {
  constructor(private apiService: ApiService) {}

  public getAllCustomsCountries(): Observable<CountryModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/countries`, null, { isShowLoader: false });
  }

  public getAllMarineInsuranceCountries(): Observable<CountryModel[]> {
    return this.apiService.get(`${environment.url.prefixInsurance}v2/countries`, null, { isShowLoader: false });
  }

  public getAllIsfUnits(): Observable<UnitModel[]> {
    return this.apiService.get<UnitModel[]>(`${environment.url.prefixCustoms}v2/isf-units`, null, { isShowLoader: false });
  }

  public getAllIncoterms(): Observable<IncoTermModel[]> {
    return this.apiService
      .get<IncoTermModel[]>(`${environment.url.prefixCustoms}v2/incoterms`, null, { isShowLoader: false })
      .pipe(map((items: IncoTermModel[]) => items.sort((incoterm: IncoTermModel) => (FIRST_INCOTERMS.includes(incoterm.code) ? -1 : 0))));
  }

  public getAllLineUnits(): Observable<UnitModel[]> {
    return this.apiService.get<UnitModel[]>(`${environment.url.prefixCustoms}v2/line-units`, null, { isShowLoader: false });
  }

  public getAllShipmentUnits(): Observable<UnitModel[]> {
    return this.apiService.get<UnitModel[]>(`${environment.url.prefixCustoms}v2/shipment-units`, null, { isShowLoader: false });
  }

  public getAllCurrencies(): Observable<CurrencyModel[]> {
    return this.apiService.get<CurrencyModel[]>(`${environment.url.prefixCustoms}v2/currencies`, null, { isShowLoader: false });
  }
}
